module.exports = __webpack_public_path__ + "static/media/MensShirtTwo.eea46664.webp";